import { createReducer } from '@reduxjs/toolkit'

import { Status } from '../interfaces'
import { fetchIncentives, fetchPools } from './actions'
import { FarmState } from './interfaces'

const initialState: FarmState = {
  pool: {
    status: Status.INITIAL,
    data: {},
  },
  incentive: {
    status: Status.INITIAL,
    data: {},
  },
}

export default createReducer<FarmState>(initialState, (builder) =>
  builder
    .addCase(fetchPools.pending, (state) => {
      state.pool = { ...state.pool, status: Status.PENDING }
    })
    .addCase(fetchPools.rejected, (state) => {
      state.pool = { ...state.pool, status: Status.ERROR }
    })
    .addCase(fetchPools.fulfilled, (state, { payload }) => {
      state.pool = { data: payload, status: Status.SUCCESS }
    })
    .addCase(fetchIncentives.pending, (state) => {
      state.incentive = { ...state.incentive, status: Status.PENDING }
    })
    .addCase(fetchIncentives.rejected, (state) => {
      state.incentive = { ...state.incentive, status: Status.ERROR }
    })
    .addCase(fetchIncentives.fulfilled, (state, { payload }) => {
      state.incentive = { data: payload, status: Status.SUCCESS }
    })
)
